import React, { useState, useEffect } from 'react';
import socketService from '../services/socketService';
import Layout from '../components/Layout';
import ResilientImage from '../components/ResilientImage';

const AppTransaction = () => {
    // 🟢 লগ-ইন করা ইউজারের ডাটা (আপনার সিস্টেম অনুযায়ী এটি localStorage থেকে আসবে)
    const currentUser = JSON.parse(localStorage.getItem('user')) || {}; 
    
    // 🟢 Masterkey বা পারমিশন চেক
    const hasPermission = currentUser?.role === 'admin' || currentUser?.masterKey === true || currentUser?.permissions?.apptransactionscheck === true; 

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // 🟢 নতুন স্টেট: ছবি বড় করে দেখার জন্য
    const [selectedImage, setSelectedImage] = useState(null);

    const [users, setUsers] = useState([]);
    const [devices, setDevices] = useState([]);
    
    // 🟢 ফিল্টার, পেজিনেশন এবং সামারি স্টেট
    const [filters, setFilters] = useState({ startDate: '', endDate: '', searchTrx: '' });
    const [page, setPage] = useState(1);
    const limit = 20; 
    const [summary, setSummary] = useState({ totalRecords: 0, totalAmount: 0, totalPages: 1 });

    const [formData, setFormData] = useState({
        userId: '', senderID: '', status: 'pending', deviceName: '', transactionID: '', message: 'N/A' 
    });

    const isMaster = localStorage.getItem('isMaster') === 'true';
    const rawAllowedUsers = JSON.parse(localStorage.getItem('allowedUsers') || '[]');
const allowedUserIds = rawAllowedUsers.map(user => 
    typeof user === 'object' && user.$oid ? user.$oid : user
);

    useEffect(() => {
        socketService.connect();

        socketService.on('app-transactions-data', (response) => {
            if (response.data) {
                setTransactions(response.data);
                setSummary({
                    totalRecords: response.totalRecords || 0,
                    totalAmount: response.totalAmount || 0,
                    totalPages: response.totalPages || 1
                });
            } else {
                setTransactions(response); 
            }
            setLoading(false);
        });

        socketService.on('add-app-transaction-response', (response) => {
            if (response.success) {
                alert(response.message);
                setFormData({ userId: '', senderID: '', status: 'pending', deviceName: '', transactionID: '', message: 'N/A' });
                fetchData(1); 
            } else {
                alert('Failed to add transaction: ' + response.error);
            }
        });

        // 🟢 Resend এর রেসপন্স ধরার জন্য নতুন লিসেনার
        socketService.on('resend-app-transaction-response', (response) => {
            if (response.success) {
                alert(response.message);
                fetchData(1); // ডাটা রিফ্রেশ করা হবে
            } else {
                alert('Failed to resend: ' + response.error);
            }
        });

        socketService.on('all-users-data', (data) => setUsers(data));
        socketService.on('user-devices-data', (data) => setDevices(data));

        fetchData(1);
       socketService.emit('get-all-users', { 
        isMaster: isMaster, 
        allowedUsers: allowedUserIds 
    });

        return () => {
            socketService.off('app-transactions-data');
            socketService.off('add-app-transaction-response');
            socketService.off('resend-app-transaction-response'); // 🟢 ক্লিনআপ
            socketService.off('all-users-data');
            socketService.off('user-devices-data');
        };
    }, []);

    const fetchData = (currentPage = page) => {
        setLoading(true);
        socketService.emit('get-app-transactions', {
            page: currentPage,
            limit: limit,
            startDate: filters.startDate,
            endDate: filters.endDate,
            searchTrx: filters.searchTrx,
            isMaster: isMaster,
        allowedUsers: allowedUserIds
        });
    };

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const applyFilter = () => {
        setPage(1);
        fetchData(1);
    };

    const resetFilter = () => {
        setFilters({ startDate: '', endDate: '', searchTrx: '' });
        setPage(1);
        setLoading(true);
        fetchData(1);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= summary.totalPages) {
            setPage(newPage);
            fetchData(newPage);
        }
    };

    const handleAddInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'userId') {
            setFormData(prev => ({ ...prev, userId: value, deviceName: '' }));
            if (value) socketService.emit('get-user-devices', { userId: value });
            else setDevices([]);
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleAddSubmit = (e) => {
        e.preventDefault();
        socketService.emit('add-app-transaction', formData);
    };

    // 🟢 Resend বাটন ক্লিক করলে এই ফাংশনটি কল হবে
    const handleResend = (transactionID) => {
        if (window.confirm(`Are you sure you want to resend transaction ${transactionID}?`)) {
            socketService.emit('resend-app-transaction', { transactionID: transactionID });
        }
    };

    const getSenderLogo = (sender) => {
        if (!sender) return '/logo.png'; 
        const sLower = sender.toLowerCase();
        if (sLower.includes('bkash')) return '/bkash.jpg';
        if (sLower.includes('nagad')) return '/nagad.png';
        if (sLower.includes('rocket')) return '/rocket.png';
        if (sLower.includes('whatsapp')) return '/whatsapp.png';
        return '/logo.png'; 
    };

    const getUsername = (userId) => {
        if (!userId) return 'Unknown';
        if (typeof userId === 'object' && userId.username) return userId.username;
        const user = users.find(u => u._id === userId.toString());
        return user ? user.username : 'Unknown';
    };

    const extractAmount = (msg) => {
        if (!msg || msg === 'N/A') return '-';
        const match = msg.match(/(?:Tk\.?|BDT|Amount|৳)\s*[:=-]?\s*৳?\s*([\d,]+(?:\.\d+)?)/i);
        return match ? `৳ ${match[1]}` : '-';
    };

    return (
        <Layout> 
            <div className="main-content-area">
                <style>{`
                    .main-content-area { background-color: #f4f7fa; min-height: 100vh; padding: 20px; width: 100%; }
                    .card-box { background: #ffffff; padding: 20px; border-radius: 12px; box-shadow: 0 1px 10px rgba(0,0,0,0.05); margin-bottom: 25px; }
                    .border-top-blue { border-top: 4px solid #0d6efd; }
                    .modern-input { background: #f8fafc; border: 1px solid #cbd5e1; padding: 10px 12px; border-radius: 8px; font-size: 13px; width: 100%; outline: none; transition: 0.2s; }
                    .modern-input:focus { border-color: #0d6efd; box-shadow: 0 0 0 2px rgba(13,110,253,0.1); }
                    .btn-primary { background: #0d6efd; color: white; border-radius: 8px; font-size: 14px; border: none; font-weight: 600; cursor: pointer; padding: 10px 20px; transition: 0.2s; }
                    .btn-primary:hover { background: #0b5ed7; }
                    .btn-secondary { background: #e2e8f0; color: #334155; border-radius: 8px; font-size: 14px; border: none; font-weight: 600; cursor: pointer; padding: 10px 20px; transition: 0.2s; }
                    .btn-secondary:hover { background: #cbd5e1; }
                    
                    .custom-zebra-table { width: 100%; border-collapse: collapse; }
                    .custom-zebra-table th { background: #f1f5f9; padding: 15px; font-size: 12px; font-weight: 800; text-transform: uppercase; color: #475569; border-bottom: 2px solid #e2e8f0; text-align: left; }
                    .custom-zebra-table td { padding: 15px; border-bottom: 1px solid #edf2f7; vertical-align: middle; font-size: 13px; }
                    .status-unseen { background: #fff7ed; color: #ea580c; padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 700; border: 1px solid #ffedd5; }
                    .status-seen { background: #f0fdf4; color: #16a34a; padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 700; border: 1px solid #bbf7d0; display: inline-block; }
                    
                    .section-title { font-size: 18px; color: #1e293b; font-weight: 700; margin-bottom: 20px; }
                    .sender-info { display: flex; align-items: center; gap: 8px; font-weight: 600; }
                    .sender-logo { width: 24px; height: 24px; border-radius: 50%; object-fit: cover; border: 1px solid #e2e8f0; }
                    .user-dev-container { display: flex; flex-direction: column; gap: 4px; }
                    .clear-device { font-size: 12px; font-weight: 600; color: #475569; }
                    .clear-username { font-size: 14px; font-weight: 800; color: #059669; }
                    .amount-text { font-weight: 800; color: #10b981; font-size: 15px; background: #ecfdf5; padding: 4px 8px; border-radius: 6px;}

                    .filter-grid { display: grid; grid-template-columns: 1fr 1fr 1.5fr auto auto; gap: 15px; align-items: end; margin-bottom: 20px; }
                    .summary-container { display: flex; gap: 20px; margin-bottom: 20px; }
                    .summary-box { flex: 1; background: #fff; border-left: 5px solid #0d6efd; padding: 20px; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.04); display: flex; flex-direction: column; }
                    .summary-box.green { border-left-color: #10b981; }
                    .summary-label { font-size: 13px; color: #64748b; font-weight: 700; text-transform: uppercase; margin-bottom: 5px; }
                    .summary-value { font-size: 24px; font-weight: 800; color: #1e293b; }
                    
                    .pagination { display: flex; justify-content: flex-end; align-items: center; gap: 15px; padding: 20px; border-top: 1px solid #e2e8f0; }
                    .page-btn { padding: 8px 15px; background: #fff; border: 1px solid #cbd5e1; border-radius: 6px; cursor: pointer; font-weight: 600; color: #334155; transition: 0.2s;}
                    .page-btn:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }
                    .page-btn:disabled { opacity: 0.5; cursor: not-allowed; }
                    .page-info { font-size: 13px; font-weight: 600; color: #475569; }
                `}</style>

                <div className="card-box border-top-blue">
                    <h3 className="section-title">Add New App Transaction</h3>
                    <form onSubmit={handleAddSubmit}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '15px' }}>
                            <select name="userId" className="modern-input" value={formData.userId} onChange={handleAddInputChange} required>
                                <option value="">-- Select User --</option>
                                {users.map(u => <option key={u._id} value={u._id}>{u.username}</option>)}
                            </select>
                            
                            <select name="deviceName" className="modern-input" value={formData.deviceName} onChange={handleAddInputChange} required>
                                <option value="">-- Select Device --</option>
                                {devices.map(device => <option key={device._id} value={device.deviceName}>{device.deviceName}</option>)}
                            </select>
                            
                            {/* 🔥 Sender ID Text Input er bodole ekhane Dropdown Select Option kora holo */}
                            <select name="senderID" className="modern-input" value={formData.senderID} onChange={handleAddInputChange} required>
                                <option value="">-- Select Sender ID --</option>
                                <option value="bKash">bKash</option>
                                <option value="NAGAD">NAGAD</option>
                            </select>

                            <input type="text" name="transactionID" placeholder="Transaction ID" className="modern-input" value={formData.transactionID} onChange={handleAddInputChange} required />
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <button type="submit" className="btn-primary">+ Save Transaction</button>
                        </div>
                    </form>
                </div>

                {/* সামারি বক্স */}
                <div className="summary-container">
                    <div className="summary-box">
                        <span className="summary-label">Total Found Trx</span>
                        <span className="summary-value">{summary.totalRecords}</span>
                    </div>
                    <div className="summary-box green">
                        <span className="summary-label">Total Amount</span>
                        <span className="summary-value" style={{ color: '#10b981' }}>৳ {summary.totalAmount.toFixed(2)}</span>
                    </div>
                </div>

                {/* ডাটা টেবিল ও ফিল্টার */}
                <div className="card-box" style={{ padding: 0, overflow: 'hidden' }}>
                    <div style={{ padding: '20px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
                        <h4 style={{ margin: '0 0 15px 0', color: '#334155', fontWeight: '700' }}>Recent Transactions</h4>
                        
                        <div className="filter-grid">
                            <div>
                                <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#64748b', display: 'block', marginBottom: '5px' }}>Start Date</label>
                                <input type="date" name="startDate" className="modern-input" value={filters.startDate} onChange={handleFilterChange} style={{ margin: 0 }} />
                            </div>
                            <div>
                                <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#64748b', display: 'block', marginBottom: '5px' }}>End Date</label>
                                <input type="date" name="endDate" className="modern-input" value={filters.endDate} onChange={handleFilterChange} style={{ margin: 0 }} />
                            </div>
                            <div>
                                <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#64748b', display: 'block', marginBottom: '5px' }}>Search Trx ID</label>
                                <input type="text" name="searchTrx" placeholder="Enter Transaction ID..." className="modern-input" value={filters.searchTrx} onChange={handleFilterChange} style={{ margin: 0 }} />
                            </div>
                            <button onClick={applyFilter} className="btn-primary">Search</button>
                            <button onClick={resetFilter} className="btn-secondary">Reset</button>
                        </div>
                    </div>

                    <table className="custom-zebra-table">
                        <thead>
                            <tr>
                                <th>Transaction ID</th>
                                <th>Device & User</th>
                                <th>Sender ID</th>
                                <th>Receipt</th>
                                <th>Amount</th> 
                                <th>Message</th>
                                <th>Status</th>
                                <th>Seen By</th>
                                <th>Date</th>
                                <th>Action</th> {/* 🟢 নতুন কলাম যোগ করা হয়েছে */}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="10" style={{ padding: '60px', textAlign: 'center', color: '#94a3b8' }}>Loading data...</td></tr>
                            ) : transactions.length > 0 ? (
                                transactions.map((txn, index) => (
                                    <tr key={index}>
                                        <td><strong>{txn.transactionID}</strong></td>
                                        <td>
                                            <div className="user-dev-container">
                                                <span className="clear-device"><i className="fas fa-mobile-alt"></i> {txn.deviceName}</span>
                                                <span className="clear-username">{getUsername(txn.userId)}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="sender-info">
                                                <ResilientImage src={getSenderLogo(txn.senderID)} alt="logo" className="sender-logo" />
                                                {txn.senderID}
                                            </div>
                                        </td>
                                        <td>
                                            {txn.receipt_image ? (
                                                <ResilientImage
                                                    src={txn.receipt_image} 
                                                    alt="Receipt" 
                                                    style={{ 
                                                        width: '45px', 
                                                        height: '45px', 
                                                        objectFit: 'cover', 
                                                        borderRadius: '6px', 
                                                        cursor: 'pointer', 
                                                        border: '1px solid #cbd5e1',
                                                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                                                    }}
                                                    onClick={() => setSelectedImage(txn.receipt_image)}
                                                />
                                            ) : (
                                                <span style={{ fontSize: '11px', color: '#94a3b8', fontStyle: 'italic' }}>No Image</span>
                                            )}
                                        </td>
                                        <td><span className="amount-text">{extractAmount(txn.message)}</span></td>
                                        <td style={{ maxWidth: '200px', wordWrap: 'break-word' }}>{txn.message}</td>
                                        <td>
                                            <span className={txn.status === 'pending' ? 'status-unseen' : 'status-seen'}>
                                                {txn.status ? txn.status.toUpperCase() : 'UNKNOWN'}
                                            </span>
                                        </td>
                                        <td>
                                            {txn.seenBy ? (
                                                <span style={{ color: '#16a34a', fontWeight: '600' }}>{txn.seenBy}</span>
                                            ) : (
                                                <span style={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '12px' }}>Not Seen</span>
                                            )}
                                        </td>
                                        <td>{new Date(txn.receivedAt).toLocaleString('en-US')}</td>
                                        
                                        {/* 🟢 Resend বাটন কলাম */}
                                        <td>
                                            {txn.status === 'invalid' && (
                                                <button 
                                                    onClick={() => handleResend(txn.transactionID)}
                                                    style={{
                                                        background: '#f59e0b', color: 'white', border: 'none', 
                                                        padding: '6px 12px', borderRadius: '6px', cursor: 'pointer',
                                                        fontSize: '12px', fontWeight: 'bold', display: 'flex', 
                                                        alignItems: 'center', gap: '5px', transition: '0.2s'
                                                    }}
                                                    onMouseOver={(e) => e.target.style.background = '#d97706'}
                                                    onMouseOut={(e) => e.target.style.background = '#f59e0b'}
                                                >
                                                    <i className="fas fa-redo"></i> Resend
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="10" style={{ padding: '60px', textAlign: 'center', color: '#94a3b8' }}>No transactions found</td></tr>
                            )}
                        </tbody>
                    </table>

                    {!loading && summary.totalPages > 1 && (
                        <div className="pagination">
                            <button className="page-btn" disabled={page === 1} onClick={() => handlePageChange(page - 1)}>
                                &laquo; Prev
                            </button>
                            <span className="page-info">Page {page} of {summary.totalPages}</span>
                            <button className="page-btn" disabled={page === summary.totalPages} onClick={() => handlePageChange(page + 1)}>
                                Next &raquo;
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* 🟢 Image Zoom Modal */}
            {selectedImage && (
                <div 
                    style={{
                        position: 'fixed',
                        top: 0, left: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        zIndex: 9999,
                        backdropFilter: 'blur(5px)' 
                    }}
                    onClick={() => setSelectedImage(null)} 
                >
                    <div 
                        style={{ position: 'relative', padding: '10px' }}
                        onClick={(e) => e.stopPropagation()} 
                    >
                        <button 
                            style={{
                                position: 'absolute', top: '-15px', right: '-15px',
                                background: '#ef4444', color: 'white', border: 'none',
                                borderRadius: '50%', width: '35px', height: '35px',
                                fontSize: '16px', fontWeight: 'bold', cursor: 'pointer',
                                boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                                display: 'flex', justifyContent: 'center', alignItems: 'center'
                            }}
                            onClick={() => setSelectedImage(null)}
                        >
                            X
                        </button>
                        
                        <ResilientImage
                            src={selectedImage} 
                            alt="Enlarged Receipt" 
                            style={{ 
                                maxWidth: '90vw', 
                                maxHeight: '85vh', 
                                borderRadius: '12px', 
                                boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
                                objectFit: 'contain'
                            }} 
                        />
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default AppTransaction;
